import { render, staticRenderFns } from "./PagamentosEmProcessamento.vue?vue&type=template&id=3f703e12"
import script from "./PagamentosEmProcessamento.vue?vue&type=script&lang=js"
export * from "./PagamentosEmProcessamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports